import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-arrow-left-button',
  templateUrl: './arrow-left-button.component.html',
  styles: []
})
export class ArrowLeftButtonComponent implements OnInit {

  @Output() close = new EventEmitter();

  isHovered = false;

  constructor() { }

  ngOnInit(): void {
  }

  onHover(isHoverd: boolean) {
    this.isHovered = isHoverd;
  }

  onClick() {
    this.close.emit();
  }

}
